;(function () {
  angular
    .module('contrast.notifications')
    .controller('csCustomNotificationsCtrl', csCustomNotificationsCtrl)

  function csCustomNotificationsCtrl(
    $scope,
    $filter,
    $q,
    $uibModal,
    $timeout,
    $translate,
    dialogs,
    logger,
    permissions,
    csTemplates,
    AlertFactory,
    OrganizationAlertFactory,
    FeaturesFactory,
    ErrorService,
    AlertService
  ) {
    'ngInject'

    var _searchKeywords = '',
      _delay = 300,
      _deleteAlertTemplateUrl = 'components-org/notifications/delete.html',
      _modalAlertTpl = 'components-org/notifications/modal-alert.html',
      _modalAlertFullTpl = 'components-org/notifications/modal-alert-full.html'

    var translGlobal = {
      detail_unableToLoadRemoveDialog: $translate.instant(
        'detail_unableToLoadRemoveDialog'
      ),
      title_pleaseConfirmAction: $translate.instant(
        'title_pleaseConfirmAction'
      ),
      action_cancel: $translate.instant('action_cancel'),
      action_delete: $translate.instant('action_delete'),
      title_notificationsSettings_createNotification: $translate.instant(
        'title_notificationsSettings_createNotification'
      ),
      title_notificationsSettings_editNotification: $translate.instant(
        'title_notificationsSettings_editNotification'
      ),
      title_notificationsSettings_frequencyOnEvent: $translate.instant(
        'title_notificationsSettings_frequencyOnEvent'
      ),
      title_notificationsSettings_frequencyDaily: $translate.instant(
        'title_notificationsSettings_frequencyDaily'
      ),
      title_notificationsSettings_frequencyWeekly: $translate.instant(
        'title_notificationsSettings_frequencyWeekly'
      )
    }

    function init() {
      isRaspEnabled().then(function () {
        loadNotifications()
      })
    }

    //Variables
    angular.extend($scope, {
      //Data Related Configs/Containers
      data: {
        numPerLoad: 10,
        loadPromise: null,
        busy: true,
        row: '',
        notifications: {
          all: [],
          displayed: [],
          filtered: []
        },
        searchKeywords: function (newSearchKeywords) {
          if (!arguments.length) {
            return _searchKeywords
          }

          if (newSearchKeywords !== _searchKeywords) {
            _searchKeywords = newSearchKeywords
          }

          //do some stuff
          clearNotifications()
          applyFilters()
          loadNotificationsForDisplay($scope.data.numPerLoad)

          return _searchKeywords
        },

        showAlertAttacks: false
      },

      updating: false,
      updatingAttack: false
    })

    //Methods
    angular.extend($scope, {
      loadByScroll: function () {
        var displayedCount = $scope.data.notifications.displayed.length,
          filteredCount = $scope.data.notifications.filtered.length

        if (displayedCount == filteredCount || filteredCount == 0) {
          return
        }

        loadNotificationsForDisplay(displayedCount + $scope.data.numPerLoad)
      },

      order: function (rowName) {
        if ($scope.data.row === rowName) {
          return
        }

        $scope.data.row = rowName
        clearNotifications()
        applyFilters()
        loadNotificationsForDisplay($scope.data.numPerLoad)
      },

      convertToSymbols: function (word) {
        return AlertService.convertToSymbols(word)
      },

      changeStatus: function (alert) {
        $scope.updating = true

        AlertFactory.updateAlertStatus(alert.alert_id).then(
          function (response) {
            logger.logSuccess(response.data.messages[0])
            $scope.updating = false
          },
          function (response) {
            $scope.updating = false
            ErrorService.processError(response)
          }
        )
      },

      launchSingleDeleteDialog: function (alert) {
        return csTemplates
          .loadAndInterpolate(_deleteAlertTemplateUrl, {
            alertName: alert.name
          })
          .then(
            function (interpolatedStr) {
              $scope.launchDialog([alert], interpolatedStr)
            },
            function () {
              logger.logError(translGlobal.detail_unableToLoadRemoveDialog)
            }
          )
      },

      showAllApps: function (alert) {
        alert.limit = 'Infinity'
      },

      launchDialog: function (alerts, msg) {
        dialogs
          .confirm(translGlobal.title_pleaseConfirmAction, msg, {
            size: 'sm',
            yes: translGlobal.action_delete,
            no: translGlobal.action_cancel
          })
          .result.then(function () {
            var deferred = $q.defer()
            var promises = []
            angular.forEach(alerts, function (alert) {
              var request = AlertFactory.deleteAlert(alert.alert_id).then(
                function (response) {
                  logger.logSuccess(response.data.messages[0])
                },
                function (response) {
                  ErrorService.processError(response)
                }
              )

              promises.push(request)
            })

            $q.all(promises).then(
              function (results) {
                deferred.resolve(JSON.stringify(results))
                loadNotifications()
              },
              function (errors) {
                deferred.reject(errors)
              },
              function (updates) {
                deferred.update(updates)
              }
            )

            return deferred.promise
          })
      },

      changeStatusAttack: function (alert) {
        $scope.updatingAttack = true

        AlertFactory.updateAlertAttackStatus(alert.alert_id).then(
          function (response) {
            logger.logSuccess(response.data.messages[0])
            $scope.updatingAttack = false
          },
          function (response) {
            $scope.updatingAttack = false
            ErrorService.processError(response)
          }
        )
      },

      launchSingleDeleteDialogAttack: function (alert) {
        return csTemplates
          .loadAndInterpolate(_deleteAlertTemplateUrl, {
            alertName: alert.name
          })
          .then(
            function (interpolatedStr) {
              $scope.launchDialogAttack([alert], interpolatedStr)
            },
            function () {
              logger.logError(translGlobal.detail_unableToLoadRemoveDialog)
            }
          )
      },

      launchDialogAttack: function (alerts, msg) {
        dialogs
          .confirm(translGlobal.title_pleaseConfirmAction, msg, {
            size: 'sm',
            yes: translGlobal.action_delete,
            no: translGlobal.action_cancel
          })
          .result.then(function () {
            var deferred = $q.defer()
            var promises = []
            angular.forEach(alerts, function (alert) {
              var request = AlertFactory.deleteAlertAttack(alert.alert_id).then(
                function (response) {
                  logger.logSuccess(response.data.messages[0])
                },
                function (response) {
                  ErrorService.processError(response)
                }
              )

              promises.push(request)
            })

            $q.all(promises).then(
              function (results) {
                deferred.resolve(JSON.stringify(results))
                loadNotifications()
              },
              function (errors) {
                deferred.reject(errors)
              },
              function (updates) {
                deferred.update(updates)
              }
            )

            return deferred.promise
          })
      },

      addAlert: function () {
        var modalInstance
        modalInstance = $uibModal.open({
          templateUrl: _modalAlertTpl,
          controller: 'ModalAlertInstanceCtrl',
          backdrop: 'static',
          size: 'lg-md',
          resolve: {
            showAlertAttacks: function () {
              return false
            },
            title: function () {
              return translGlobal.title_notificationsSettings_createNotification
            }
          }
        })

        modalInstance.result.then(function () {
          loadNotifications()
        })
      },

      addAlertFull: function () {
        var modalInstance = $uibModal.open({
          templateUrl: _modalAlertFullTpl,
          controller: 'ModalAlertInstanceCtrl',
          backdrop: 'static',
          size: 'lg',
          resolve: {
            showAlertAttacks: function () {
              return true
            },
            title: function () {
              return translGlobal.title_notificationsSettings_createNotification
            }
          }
        })

        modalInstance.result.then(function () {
          loadNotifications()
        })
      },

      editAlert: function (alert) {
        var modalInstance = $uibModal.open({
          templateUrl: _modalAlertTpl,
          controller: 'ModalEditAlertInstanceCtrl',
          backdrop: 'static',
          size: 'lg-md',
          resolve: {
            alert: function () {
              return angular.copy(alert)
            },
            title: function () {
              return translGlobal.title_notificationsSettings_editNotification
            }
          }
        })

        modalInstance.result.then(function () {
          loadNotifications()
        })
      },

      editAlertAttack: function (alert) {
        var modalInstance
        modalInstance = $uibModal.open({
          templateUrl: _modalAlertTpl,
          controller: 'ModalEditAlertAttackInstanceCtrl',
          backdrop: 'static',
          size: 'lg',
          resolve: {
            alert: function () {
              return angular.copy(alert)
            },
            title: function () {
              return translGlobal.title_notificationsSettings_editNotification
            }
          }
        })

        modalInstance.result.then(function () {
          loadNotifications()
        })
      },
      getAlertFrequencyDisplay: getAlertFrequencyDisplay
    })

    function isRaspEnabled() {
      return FeaturesFactory.getFeaturesByKeys(['rasp']).then(function (
        response
      ) {
        if (response.data[0].active) {
          $scope.data.showAlertAttacks = permissions.isRASPEnabled()
        } else {
          $scope.data.showAlertAttacks = false
        }
      })
    }

    function loadNotifications() {
      $scope.data.busy = true

      if ($scope.data.showAlertAttacks) {
        $scope.data.loadPromise = OrganizationAlertFactory.getAlerts()
      } else {
        $scope.data.loadPromise = AlertFactory.getAlerts()
      }

      return $scope.data.loadPromise.then(
        function (response) {
          $scope.data.notifications.all = response.data.alerts

          clearNotifications()
          applyFilters()
          loadNotificationsForDisplay($scope.data.numPerLoad)
        },
        function (response) {
          $scope.data.busy = false

          ErrorService.processError(response)
        }
      )
    }

    function loadNotificationsForDisplay(limit) {
      var displayCount =
        $scope.data.notifications.filtered.length < limit
          ? $scope.data.notifications.filtered.length
          : limit
      displayCount = displayCount ? displayCount : 0

      $scope.data.busy = true

      $scope.data.loadPromise = $q(function (resolve) {
        $timeout(function () {
          resolve()
        }, _delay)
      })

      return $scope.data.loadPromise.then(function () {
        $scope.data.notifications.displayed =
          $scope.data.notifications.filtered.slice(0, displayCount)

        $scope.data.busy = false

        $timeout(function () {
          $scope.$emit('triggerScrollCheck')
        })
      })
    }

    function clearNotifications() {
      $scope.data.notifications.displayed = []
      $scope.data.notifications.filtered = []
    }

    function applyFilters() {
      $scope.data.notifications.filtered = $filter('filter')(
        $scope.data.notifications.all,
        filterFunction
      )
      $scope.data.notifications.filtered = $filter('orderBy')(
        $scope.data.notifications.filtered,
        $scope.data.row
      )
    }

    var filterFunction = function (alert) {
      var val = $scope.data.searchKeywords().toLowerCase()
      return alert.name.toLowerCase().indexOf(val || '') !== -1
    }

    var alertFrequencyLookup = {
      weekly: translGlobal.title_notificationsSettings_frequencyWeekly,
      daily: translGlobal.title_notificationsSettings_frequencyDaily,
      onevent: translGlobal.title_notificationsSettings_frequencyOnEvent
    }

    function getAlertFrequencyDisplay(frequency) {
      if (alertFrequencyLookup[frequency]) {
        return alertFrequencyLookup[frequency]
      }
      return frequency
    }

    init()
  }
})()
